import { CalendarClock, CircleDollarSign, Mail, Sparkles } from 'lucide-react';
import PageHero from '../components/PageHero';
import Seo from '../components/Seo';
import { CONTACT } from '../data/siteData';

export default function Neighborhood() {
  const faqs = [
    ['Does a neighbourhood visit cost money?', 'Neighbourhood visits are generally offered without a standard appearance fee, although donations are appreciated and larger or extended events may require a custom arrangement.'],
    ['Can we request a holiday visit?', 'Yes. Availability depends on the holiday, duration, location, access and the current roadside workload. Send the date, neighbourhood and expected event details for review.'],
    ['How far ahead should we ask?', 'Contact us at least one to two weeks ahead whenever possible. Major holiday dates often fill earlier.'],
  ];
  return (
    <>
      <Seo title="Jonny’s In Your Neighbourhood" description="Holiday-decorated Jonny's Towing trucks, neighbourhood visits and community appearances in Richmond, BC." image="/images/christmas-truck.webp" />
      <PageHero
        eyebrow="We do things differently. Period."
        title="Black trucks. Bright-pink accents. Holiday experiences built in-house."
        description="You may see our fleet transformed with Christmas lights, talking pumpkins, skeleton crews and interactive props designed to make the neighbourhood smile."
        image="/images/christmas-truck.webp"
      >
        <a className="button button--primary" href={`mailto:${CONTACT.email}?subject=Holiday%20Neighbourhood%20Visit`}><Mail size={18} /> Request a visit</a>
      </PageHero>
      <section className="section container feature-split">
        <div className="feature-image-wrap feature-image-wrap--collage">
          <img src="/images/halloween-truck.webp" alt="Halloween-decorated Jonny's Towing flatbed" />
          <img src="/images/christmas-fleet.webp" alt="Jonny's Towing Christmas-decorated fleet" />
        </div>
        <div className="feature-copy">
          <Sparkles size={36} />
          <span className="eyebrow">Holiday events? We do those.</span>
          <h2>Technology, fabrication and a lot of imagination.</h2>
          <p>Halloween is a favourite because it gives our team room to build interactive props, talking jack-o’-lantern crews, animatronic skeletons and eerie lighting that turns the fleet into a moving experience.</p>
          <p>Christmas brings a different energy: wreaths, illuminated trees, ornaments and bright details that turn ordinary roadside vehicles into a community attraction.</p>
        </div>
      </section>
      <section className="section section--dark">
        <div className="container faq-grid">
          {faqs.map(([question, answer], index) => {
            const Icon = [CircleDollarSign, CalendarClock, CalendarClock][index];
            return <article className="faq-card" key={question}><Icon /><h3>{question}</h3><p>{answer}</p></article>;
          })}
        </div>
      </section>
    </>
  );
}
